import { render, staticRenderFns } from "./Valor-diferenciado.vue?vue&type=template&id=dfae1fde&"
import script from "./Valor-diferenciado.vue?vue&type=script&lang=js&"
export * from "./Valor-diferenciado.vue?vue&type=script&lang=js&"
import style0 from "./Valor-diferenciado.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports